import packageInfo from '../../../../package.json';

export const environment = {
  production: true,
  version: `v${packageInfo.version}`,
  graphql: {
    uri: 'https://api.iqd-pro.com/graphql',
    wsUri: 'wss://api.iqd-pro.com/graphql',
  },
  sentry: {
    dsn: 'https://0628eaf5015562c219b48ae89cf316b7@o4509351712194560.ingest.de.sentry.io/4509354974969936',
    environment: 'production',
  },
};
